import { ApplicationClassificationProvider } from '@/lib/applications/application-classification-context';
import { resolveManifestForPath } from '@/lib/applications/application-manifest';
import { Header } from './Header';
import { useLocation } from 'react-router-dom';
import { SidebarProvider } from './sidebar-context';
import { WorkspaceSidebar } from './WorkspaceSidebar';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { pathname } = useLocation();
  // Full-bleed apps own their own in-app navigation (no hosted nav groups), so the shell
  // gets out of their way instead of reserving space for a sidebar they'll never populate.
  const isFullBleedWorkspace = resolveManifestForPath(pathname).navGroups.length === 0;

  return (
    <ApplicationClassificationProvider>
      <SidebarProvider>
        <div className="flex h-screen flex-col overflow-hidden">
          <Header />

          <main
            className="flex min-h-0 flex-1"
            style={{ backgroundColor: 'var(--color-surface-page)' }}
          >
            <div className="flex min-h-0 w-full flex-1 animate-fade-in flex-col lg:flex-row">
              {!isFullBleedWorkspace ? <WorkspaceSidebar /> : null}
              <div
                className={
                  isFullBleedWorkspace
                    ? "flex min-h-0 w-full flex-1 flex-col overflow-y-auto"
                    : "mx-auto flex min-h-0 w-full max-w-[var(--content-max-width)] flex-1 flex-col overflow-y-auto px-[var(--content-padding-x)] py-6"
                }
              >
                {children}
              </div>
            </div>
          </main>
        </div>
      </SidebarProvider>
    </ApplicationClassificationProvider>
  );
}
